import React from 'react';

function AlertIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21.3C7 21.3 3 17.2 3 12.3C3 7.40005 7.1 3.30005 12 3.30005C17 3.30005 21 7.40005 21 12.3C21 17.2 17 21.3 12 21.3ZM12 5.20005C8.2 5.20005 5 8.40005 5 12.2C5 16 8.2 19.2 12 19.2C15.8 19.2 19 16 19 12.2C19 8.40005 15.9 5.20005 12 5.20005ZM13 16.4V11.8C13 11.2 12.6 10.8 12 10.8C11.4 10.8 11 11.2 11 11.8V16.4C11 17 11.4 17.4 12 17.4C12.6 17.4 13 16.9 13 16.4ZM13 8.30005V8.00005C13 7.40005 12.6 7.00005 12 7.00005C11.4 7.00005 11 7.40005 11 8.00005V8.30005C11 8.90005 11.4 9.30005 12 9.30005C12.6 9.30005 13 8.90005 13 8.30005Z"
        fill="#EF4136"
      />
    </svg>
  );
}

export default AlertIcon;
